export default __webpack_public_path__ + "static/media/Watch-Cart-DecideLater.fcab2b55.gif";